var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoNotesSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F6F6",
    width: 48,
    height: 48,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17.25a.75.75 0 1 1 0 1.5h-4.75a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V26a.75.75 0 1 1 1.5 0v4.75a3 3 0 0 1-3 3h-10.5a3 3 0 0 1-3-3v-10.5a3 3 0 0 1 3-3H22zm8.019-2.981a2.625 2.625 0 0 1 3.712 3.712l-10.619 10.62a5.25 5.25 0 0 1-2.213 1.318l-2.685.8a.75.75 0 0 1-.933-.933l.8-2.685a5.25 5.25 0 0 1 1.319-2.213l8.932-8.931.006-.007 1.68-1.681zm-1.158 3.278-8.4 8.401a3.75 3.75 0 0 0-.942 1.581l-.405 1.356 1.357-.404a3.75 3.75 0 0 0 1.41-.782l.17-.16 8.401-8.401-1.591-1.591zm3.81-2.218a1.125 1.125 0 0 0-1.592 0l-1.157 1.157 1.591 1.59 1.158-1.155a1.125 1.125 0 0 0 .087-1.494l-.087-.098z",
    fill: "#979797",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotesSquare);
export default __webpack_public_path__ + "static/media/ico-notes-square.05b8befb414c8c4519e80ca55a160f52.svg";
export { ForwardRef as ReactComponent };